// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoMwaa } from '../../../assets/images/Logos/logo-mwaa.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoMwaaIcon = /* @__PURE__ */ withLogoClass(LogoMwaa);
